"use strict";

(function () {
  var enlist = {
    data: {},
    setLocalData: function setLocalData(name, value, days) {
      if (typeof window.localStorage === 'undefined') {
        setCookie(name, value, days);
      } else {
        localStorage.setItem(name, value);
      }
    },
    getLocalData: function getLocalData(name) {
      var result;
      if (typeof window.localStorage === 'undefined') {
        result = getCookie(name);
      } else {
        result = localStorage.getItem(name);
      }
      return result;
    },
    setEnroll: function setEnroll() {
      if (this.data === null || this.data === '') {
        this.setLocalData('enlist_cic_online', 1, 365);
        this.changeURL();
      }
    },
    changeURL: function changeURL() {
      console.log('change url');
      var headerCTA = document.querySelector('.hero__action .button:first-child') || null;
      var devenirClientLink = document.querySelector('#ei_tpl_devenirclient a') || null;
      if (headerCTA !== null) {
        headerCTA.innerHTML = 'Ouvrir un compte en ligne';
        headerCTA.href = '/fr/particuliers/comptes/ouvrir-un-compte.html';
      }
      if (devenirClientLink !== null) {
        devenirClientLink.href = '/fr/particuliers/comptes/ouvrir-un-compte-EER.html';
      }
    },
    hideTile: function hideTile() {
      var target = document.querySelector('[data-ga-tile="[NoModel-Tuile-Ouvrir-Compte-En-Ligne]') || null;
      if (target !== null) {
        target.style.display = 'none';
        var myboard = document.querySelector('div.ei_cardboard');
        var msnry = new Masonry(myboard, {
          columnWidth: '.ei_gridsizer',
          gutter: '.ei_guttersizer',
          itemSelector: '.ei_cardboarditem',
          percentPosition: true
        });
      }
    },
    init: function init() {
      this.data = this.getLocalData('enlist_cic_online');
      if (this.getLocalData('enlist_cic_online')) {
        console.log('déja enlist');
        this.changeURL();
      } else {
        console.log('pas enlist');
        var random = Math.floor(Math.random() * 100);
        // this.hideTile();
        console.log('random enlist', random);
        if (random <= 34) {
          this.setEnroll();
        }
      }
    }
  };
  document.addEventListener('DOMContentLoaded', function () {
    enlist.init();
  });
})();